<div class="vacations-tools">
  <div class="vacations-tools__element" tappable app-no-double-click (throttledClick)="downloadPDF()">
    <i class="app-icon-docpdf vacations-tools__element__icon"></i>
    <p class="vacations-tools__element__text u-p5">{{ 'MOT.VACATIONS.DOWNLOAD_PDF' | translate }}</p>
  </div>
</div>
